<mat-dialog-content class="content">
  <h1 class="title" mat-dialog-title>{{ data.title }}</h1>
  <div class="description" [innerHtml]="data.description"></div>
</mat-dialog-content>
<button class="closeButton" mat-raised-button (click)="close()">{{ data.buttonText }}</button>
